<template></template>
<script>
export default {
  props: ['user'],
  mounted () {
    const me = this
    // let id = me.user._id
    this.$http.post('/api/users/logout').then((response) => {
      me.$emit('try-logout')
    })
  }
}
</script>



// WEBPACK FOOTER //
// Logout.vue?54ecbe8a